<template>
  <div>
    <el-row class="procedure-table" :gutter="20">
      <el-col :span="10" class="procedure-table__left">
        <el-card class="box-card" v-loading="loading">
          <div slot="header" class="box-header">
            <span class="box-header__title">Список процедур типа: Бани</span>
            <el-button class="box-header__button" size="mini" @click="addItem" type="primary">Добавить</el-button>
          </div>
          <template>
            <el-table
              :data="tableData"
              highlight-current-row
              @current-change="handleCurrentChange"
              class="table"
            >
              <el-table-column prop="id" label="id"></el-table-column>
              <el-table-column prop="title" label="Название">
                <template slot-scope="scope">
                  <el-link type="primary" @click="editItem(scope.row.id)">
                    {{
                      scope.row.title
                    }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column  align="center" width="140" label="Действия">
                <template slot-scope="scope">
                  <el-tooltip content="Редактировать" placement="top">
                    <el-button
                      class="table__btn"
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      circle
                      @click="editItem(scope.row.id, scope.row)"
                    />
                  </el-tooltip>
                  <el-tooltip content="Удалить" placement="top">
                    <el-popconfirm
                      class="confirmBtn"
                      @onConfirm="deleteItem(scope.row.id, scope.$index)"
                      title="Вы уверены?"
                      confirmButtonText="Да"
                      confirmButtonType="danger"
                      cancelButtonType="default"
                      cancelButtonText="Нет"
                    >
                      <el-button
                        size="mini"
                        icon="el-icon-delete"
                        circle
                        class="table__btn"
                        slot="reference"
                        type="danger"
                      />
                    </el-popconfirm>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div class="error-load" v-if="errorLoadCard">
            <p>Ошибка загрузки</p>
            <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="14">

        <el-card class="box-card">

          <!--          <div slot="header" class="box-header">-->
          <!--            <span class="box-header__title">Ограничения</span>-->
          <!--            <el-button class="box-header__button" size="mini" @click="addRestriction" type="primary" :disabled="!activeIndex">Добавить</el-button>-->
          <!--          </div>-->

          <div class="box-card__add-limitation add-limitation" v-if="activeTab == 0">
            <el-button class="add-limitation__button" size="mini" @click="addRestriction" type="primary" :disabled="!activeIndex">Добавить</el-button>
          </div>

          <el-tabs class="box-card__tabs" v-model="activeTab">
            <el-tab-pane label="По показаниям">
              <el-table v-if="activeIndex" :data="activeIndex.children" >
                <!--                <el-table-column prop="id" label="id"></el-table-column>-->
                <el-table-column prop="slug" label="Показатель"></el-table-column>
                <el-table-column prop="min_equality" label="Условие"></el-table-column>
                <el-table-column prop="min" label="Значение"></el-table-column>
                <!--                <el-table-column prop="procedure_id" label="procedure"></el-table-column>-->
                <el-table-column align="center" width="140" label="Действия">
                  <template slot-scope="scope2">
                    <el-tooltip content="Редактировать" placement="top">
                      <el-button
                        class="table__btn"
                        size="mini"
                        type="primary"
                        icon="el-icon-edit"
                        circle
                        @click="editItem(scope2.row.id, scope2.row)"
                      />
                    </el-tooltip>
                    <el-tooltip content="Удалить" placement="top">
                      <el-popconfirm
                        class="confirmBtn"
                        @onConfirm="deleteItem(scope2.row.id, scope2.$index)"
                        title="Вы уверены?"
                        confirmButtonText="Да"
                        confirmButtonType="danger"
                        cancelButtonType="default"
                        cancelButtonText="Нет"
                      >
                        <el-button
                          size="mini"
                          icon="el-icon-delete"
                          circle
                          class="table__btn"
                          slot="reference"
                          type="danger"
                        />
                      </el-popconfirm>
                    </el-tooltip>
                  </template>
                </el-table-column>

              </el-table>
              <div class="error-load" v-else>
                <p><i class="el-icon-back"></i> Пожалуйста выберите процедуру</p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="По ответам анкет">
              <el-transfer
                style="text-align: left; display: inline-block"
                v-model="transferValue"
                filterable
                :left-default-checked="[2, 3]"
                :right-default-checked="[1]"

                :titles="['Все вопросы', 'Исключения']"
                :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
                }"
                @change="handleChange"
                :data="transferData">
                <!--                <el-button class="transfer-footer" slot="left-footer" size="small">Операция</el-button>-->
                <!--                <el-button class="transfer-footer" slot="right-footer" size="small">Сохранить</el-button>-->
              </el-transfer>

            </el-tab-pane>
          </el-tabs>

          <el-divider></el-divider>
          <el-button class="transfer-footer" size="small" v-if="activeIndex">Сохранить</el-button>

        </el-card>
      </el-col>
    </el-row>

    <procedure-add
      :visible="procedureAddModal"
      @close="procedureAddModal = false"
      @update="loadLogic"
      :type="getId()"
    />
    <procedure-edit
      :visible="procedureEditModal"
      @close="procedureEditModal = false"
      @update="loadLogic"
      :type="getId()"
      :element="getId()"
    />
    <restriction-add
      :visible="restrictionAddModal"
      @close="restrictionAddModal = false"
      @update="loadLogic"
      :type="getId()"
      :element="getId()"
    />
    <restriction-edit
      :visible="restrictionEditModal"
      @close="restrictionEditModal = false"
      @update="loadLogic"
      :type="getId()"
      :element="getId()"
    />

  </div>
</template>

<script>
import ProcedureAdd from '@/components/dialog/procedure/Add'
import ProcedureEdit from '@/components/dialog/procedure/Edit'
import RestrictionAdd from '@/components/dialog/restriction/Add'
import RestrictionEdit from '@/components/dialog/restriction/Edit'

export default {
  name: 'procedure',
  data () {
    const generateData = _ => {
      const data = []
      for (let i = 1; i <= 15; i++) {
        data.push({
          key: i,
          label: `Заболевание ${i}`,
          disabled: i % 4 === 0
        })
      }
      return data
    }
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      Item: {
        title: null,
        description: null
      },
      error: null,
      cardId: null,
      selectItem: false,
      addModal: false,
      procedureAddModal: false,
      procedureEditModal: false,
      restrictionAddModal: false,
      restrictionEditModal: false,
      activeIndex: null,
      activeTab: null,
      transferValue: [1],
      transferData: generateData()
    }
  },
  created () {
    this.loading = !!1
    this.loadLogic()
  },
  components: { ProcedureAdd, ProcedureEdit, RestrictionAdd, RestrictionEdit },
  methods: {
    handleCurrentChange (row) {
      console.log('row', row)
      this.activeIndex = row
    },
    getId () {
      return this.$route.params.id
    },
    addRestriction () {
      this.restrictionAddModal = !!1
    },
    handleChange (value, direction, movedKeys) {
      console.log(value, direction, movedKeys)
    },
    loadLogic () {
      this.$api.procedureType
        .getList()
        .then((response) => {
          this.tableData = response.data.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })

      // api нет, хардкорд
      const data = { pagination: { total: 1, count: 1, per_page: 1, current_page: 1, total_pages: 1, links: { next: 'http://medtech-backend.test/api/admin/v1/doctor?limit=1&page=1', previous: 'http://medtech-backend.test/api/admin/v1/doctor?limit=1&page=1' } }, data: [{ title: 'Баня', slug: '1_hamam', children: [{ id: 1, min: 5, min_equality: '<', max: 'Баня', max_equality: '<', slug: 'next', question_restricted: [0], procedure_id: 0 }], id: 1, type: { title: 'Бани' } }, { title: 'Хамам', slug: '1_hamam', children: [{ id: 1, min: 1, min_equality: '<', max: 'Хамам', max_equality: '<', slug: 'ap_dia', question_restricted: [0], procedure_id: 0 }], id: 1, type: { title: 'Бани' } }] }

      console.log(data.data)
      this.tableData = data.data
      //
    },
    editItem (id) {
      this.selectItem = id

      this.procedureEditModal = !!1
    },
    addItem () {
      this.procedureAddModal = !!1
    },
    deleteItem (id, idIndex) {
      this.loading = !!1
      this.$api.procedure
        .delete(id)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Анкета удалена'
          })
          this.tableData.splice(idIndex, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка удаления',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }

  &__tabs {
    margin: 5px -20px 10px -20px;
  }

  .add-limitation {
    position: relative;

    &__button {
      position: absolute;
      right: 0;
      top: -2px;
    }

  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }
}

.error-load {
  font-size: 14px;
  text-align:center;
  color: #ccc;
  margin-top: 40px;
}
</style>
<style lang="scss">
.el-table .select-row {
  background: #f0f9eb;
}
</style>
